import type { ComponentType } from 'react';
import type { DialogControlProps, DialogProps } from './Dialog.tsx';
import { Dialog } from './Dialog.tsx';

export type WithDialogOptions = Omit<DialogProps, 'children' | keyof DialogControlProps>;

// Wrap dialog content so its hooks run beneath Dialog's Suspense boundary. Call at module scope.
export function withDialog<TProps extends object>(
  options: WithDialogOptions = {},
  Content: ComponentType<TProps>
) {
  function WrappedDialog(props: TProps & DialogControlProps) {
    return (
      <Dialog
        {...options}
        onAnimationEnd={props.onAnimationEnd}
        onOpenChange={props.onOpenChange}
        open={props.open}
      >
        <Content {...props} />
      </Dialog>
    );
  }

  WrappedDialog.displayName = `withDialog(${Content.displayName || Content.name || 'Component'})`;

  return WrappedDialog;
}
